'use client'
import { gtmPageview } from '@/app/libs/gtm'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'

function GoogleAnalytics() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const isFirstRender = useRef(true)

  useEffect(() => {
    // Skip the first render to avoid duplicate events with the initial GTM pageview
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    // Track page views through GTM dataLayer
    const fullPath = pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : '')
    gtmPageview(fullPath)
  }, [pathname, searchParams])

  return <></>
}

export default GoogleAnalytics
